module.exports = __webpack_public_path__ + "static/media/pencil-white.fc477ea8.svg";